import { useLocation } from 'react-router-dom';
import { sheetsAddonUseCasesData } from '../Common/SheetsAddonUseCasesData';

function SheetsAddonUseCases(){

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 

    const useCasesElements = sheetsAddonUseCasesData.map((ele, idx) => {
        return(
            <div className='useCasesEle' key={idx}>
                <div className='role'>{ele.role}</div>
                <div className='useCases'>{ele.usecases}</div>
            </div>
        )
    });

    return(
        <div id='use-cases' className='useCasesContainer'>
            <div className='useCasesWrapper'>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>
                            <div className='main'>Use Cases</div>
                            <div className='sub'>(<p style={{display: 'inline'}}>PDF to Google Sheets Converter in Action</p>)</div>
                        </div>
                        <div className='content'>
                            <div className='useCasesCont'>
                                {useCasesElements}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SheetsAddonUseCases;